<template>
  <v-dialog
    v-model="dialog_update"
    max-width="580"
    class="px-3"
    @click:outside="indirect_close_dialog()"
  >
    <v-card v-if="has_data">     
      <div 
        align="center" 
        class="headline no-wrap text-center pt-4 pb-2 px-3 font-weight-bold"
      >
        <span>{{curr_axis ? curr_axis.nombre : 'Índice de igualdad de género en IES'}}</span>
        <br><span v-if="curr_ies">{{curr_ies.nombre}}</span>
      </div>
      <div class="black--text">
        <v-row align="center" justify="center" class="mx-0">
          <v-col cols="6" class="pa-0">
            <gauge-chart
              class="pa-3"
              :value="mean_value"
              :is_dialog="is_dialog"
              :axis="curr_axis"
              :ies="curr_ies"
            />
          </v-col>
          <v-col 
            v-if="curr_ies"
            :cols="6/total_cats" 
            align="center"
            class="px-0 pt-1"
          >
            <v-img 
              :alt="curr_ies.siglas || 'La IES actual'" 
              @click=""
              contain
              class="pointer" 
              position="center"
              :max-width="image_size * 1.3"
              :max-height="image_size"
              :src="`${curr_ies.logo.split('localhost:8000').join('onigies.unam.mx')}`"
            ></v-img>
          </v-col>
          <v-col 
            v-if="curr_axis"
            :cols="6/total_cats" 
            align="center"
            class="px-0 pt-1"
          >
            <img 
              :src="curr_axis.logo"
              :alt="curr_axis.nombre_corto || curr_axis.nombre" 
              :max-width="image_size"
              :height="image_size"
              class="pointer"
              @click=""
            >
          </v-col>

          <v-col cols="6" class="pa-0">
            <inst-transv
              is_dialog
              :axis="curr_axis"
              :ies="curr_ies"
            />
          </v-col>
          <v-alert type="info" color="primary" :value="has_enhance" class="mx-3">
            Durante el año en curso, esta IES ha presentado mejoras a su avance de Institucionalización
          </v-alert>
        </v-row>
        <axis-indicators 
          class="align-self-start pa-3" 
          :axis="curr_axis"
          :ies="curr_ies"
          v-if="curr_axis"
        />
      </div>
      <v-card-actions class="mt-2">
        <v-btn
          color="grey"
          text
          @click="close_dialog_update()"
        >
          Cerrar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn  v-if="curr_axis"
                color="accent"
                :to="`/eje/${curr_axis.slug}`"
                :outlined="!!curr_ies">
          Ir a {{curr_axis.nombre_corto}}
        </v-btn>
        <v-btn 
          color="accent" 
          :to="`/ies/${curr_ies.id}`" 
          v-if="curr_ies && !hide_ies_button"
        >Ir a {{curr_ies.siglas}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>

import { mapState, } from "vuex";
import AxisIndicators from "../data_viz/AxisIndicators";
import InstTransv from "../data_viz/InstTransv";
import GaugeChart from "../charts/GaugeChart";

export default {
  name: 'InterCard',
  components: {
    AxisIndicators,
    InstTransv,
    GaugeChart,
  },
  props:{
    content_data:{
      type: Array,
      required: false,
    },
    ies:{
      type: Object,
      required: false,
    },
    is_dialog:{
      type: Number,
      required: false,
      default: 1,
    },
    period:{
      type: Number,
      required: false,
    },
    dialog_update:{
      type: Boolean,
      required: false,
      default: false,
    },    
  },
  data(){
    return {
      curr_ies: undefined,
      curr_axis: undefined,
      dialog_data: undefined,
      mean_value: undefined,
      total_cats: 0,
      has_data: false,
    }
  },
  computed:{
    ...mapState({
      indicadores: state => state.indicadores,
      ejes: state => state.ejes,
      ises: state => state.ises,
    }),
    image_size(){
      return this.total_cats == 2 ? 100 : 150 
    },
    has_enhance(){
      return this.content_data[3] || false
    },
    hide_ies_button(){
      return this.$route.name == 'ies'
    }
  },
  methods: {
    close_dialog_update(){
      this.$emit('update:dialog_update', false)
    },
    indirect_close_dialog(){
      this.close_dialog_update(false)
    },
    build_data(){
      //console.log(this.content_data)
      this.total_cats = 0
      this.mean_value = this.content_data[2]
      const axis_id = this.content_data[0]
      const ies_id = this.content_data[1]
      if (axis_id && axis_id !== 'index'){
        this.total_cats++
        this.curr_axis = this.ejes.find(ej=>ej.id==axis_id)
      }
      else
        this.curr_axis = undefined
      if (this.ies)
        this.curr_ies = this.ies
      else
        this.curr_ies = ies_id ? this.ises.find(ie=>ie.id==ies_id) : undefined
      if (ies_id || this.ies)
        this.total_cats++
      //console.log(this.curr_axis)
      //console.log(this.curr_ies)
      //console.log(this.mean_value)
      this.has_data = true
      //console.log(this.has_data)
    },

  },
  watch:{
    dialog_update(after, before){
      if (after){
        this.build_data()
      }
    }
  }  
}
</script>

<style lang="scss" scoped>
</style>